import { render, staticRenderFns } from "./ODTMenu.vue?vue&type=template&id=77d91669&scoped=true&"
import script from "./ODTMenu.vue?vue&type=script&lang=js&"
export * from "./ODTMenu.vue?vue&type=script&lang=js&"
import style0 from "./ODTMenu.vue?vue&type=style&index=0&id=77d91669&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d91669",
  null
  
)

export default component.exports